import { controllers } from "../Controllers/Controllers";

// For a hoverable tooltip positioned via `.outreach-notes-tooltip` inside a
// `.outreach-notes-cell` (or any container whose child matches
// tooltipSelector): flips it to open below instead of above when there
// isn't enough viewport room above the trigger element.
export const flipTooltipIfNeeded = (containerEl: HTMLElement, tooltipSelector = '.outreach-notes-tooltip') => {
    const tooltip = containerEl.querySelector(tooltipSelector) as HTMLElement | null
    if (!tooltip) return
    const containerRect = containerEl.getBoundingClientRect()
    const tooltipHeight = tooltip.offsetHeight || 240
    const spaceAbove = containerRect.top
    const spaceBelow = window.innerHeight - containerRect.bottom
    const showBelow = spaceAbove < tooltipHeight + 16 && spaceBelow > spaceAbove
    tooltip.classList.toggle('outreach-notes-tooltip-below', showBelow)
}

export const capitalize = (string: any) => {
    if(!string){
        return ''
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const slised = (string: string|undefined, maxlength: number) => {
  if(typeof string !== "string"){
    return string
  }
  return string.slice(0, maxlength)+`${string.length>maxlength ? '...' : ''}`
}


export const pronunciation = (count: number, txtArr: Array<string>) => {
  let cases = [2, 0, 1, 1, 1, 2];
  return txtArr[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
}


export const timeToFormat = (time: number) => {
  if(typeof time !== 'number'){
      return time
  }
  if(time<60){
      return getSmallTime(time)
  } else if(time<3600){
      return getMiddleTime(time)
  } else {
      return getBigTime(time)
  }
}

const getSmallTime = (time: number) => {
  return `00:00:${tb(time)}`;
}

const getMiddleTime = (time: number) => {
  const minutes = Math.floor(time/60);
  const seconds = time - minutes * 60;
  return `00:${tb(minutes)}:${tb(seconds)}`
}

const getBigTime = (time: number) => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time - hours*3600)/60);
  const seconds = time - minutes * 60 - hours*3600;
  return `${tb(hours)}:${tb(minutes)}:${tb(seconds)}`
}

//time beautify
const tb = (val: number) => {
  val = Math.round(val)
  return val<10 ? `0${val}`:`${val}`
}


export const makeSimplyName = (name: any) => {
  if(typeof name !== "string"){
    return name
  }
  // console.log("name", name)
  const replaced = replaceStringAll(name,[[' ','_'],[',', '%2C'],['&','%26'],['!','%21']])
  // console.log("name replaced", replaced)
  return replaced
}

export const decodeSimplyName = (name: any) => {
  if(typeof name !== "string"){
    return name
  }
  return replaceString(name,'_', ' ')
}

export const replaceStringAll = (str:string, inputs: Array<any>) => {
  try{
    var retString = str
    inputs.forEach(inp=> {
      retString = replaceString(retString,inp[0],inp[1])
    })
    return retString
  } catch(e){
    return str
  }
}

export const replaceString = (str: string, search: string, replace: string) => {
  if(typeof str !== "string"){
    return str
  }
  if(typeof str.replaceAll === "function"){
    return str.replaceAll(search, replace)
  } else {
    return replaceES5(str,search,replace)
  }
}

export const replaceES5 = (s: string, e: string, r: string) => {
    var replaced = s
    while(replaced.indexOf(e)!==-1){
        replaced = replaced.replace(e,r)
    }
    return replaced
}


export const stringParser = (strnum: string|number): number => {
  return typeof strnum === "string" ? parseInt(strnum) : strnum
}


// Function to create a user-friendly truncated filename
export const truncateFilename = (filename:any, maxLength = 20) =>{
  // If filename is already short enough, return as is
  if (filename.length <= maxLength) {
    return filename;
  }
  
  // Find the extension
  const lastDotIndex = filename.lastIndexOf('.');
  const extension = lastDotIndex !== -1 ? filename.substring(lastDotIndex) : '';
  const nameWithoutExt = lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : filename;
  
  // Calculate how much space we have for the name part
  const availableLength = maxLength - extension.length - 3; // 3 for "..."
  
  // If there's not enough space, just show extension
  if (availableLength < 2) {
    return '...' + extension;
  }
  
  // Split available space between start and end
  const startLength = Math.ceil(availableLength / 2);
  const endLength = Math.floor(availableLength / 2);
  
  const start = nameWithoutExt.substring(0, startLength);
  const end = nameWithoutExt.substring(nameWithoutExt.length - endLength);
  
  return start + '...' + end + extension;
}

export const getLocalDateTimeString = (utcString: any) => {
  if (!utcString || isNaN(Date.parse(utcString))) {
    return utcString;
  }

  const localDate = new Date(utcString);

  const year = localDate.getFullYear();
  const month = localDate.getMonth() + 1; // 0-indexed
  const day = localDate.getDate();
  const hours = localDate.getHours();
  const minutes = localDate.getMinutes();

  const pad = (n: number) => String(n).padStart(2, '0');

  return `${year}-${pad(month)}-${pad(day)} ${pad(hours)}:${pad(minutes)}`;
};

export const getRoundedLocalDateTimeString = (utcString:any) => {
  return getLocalDateTimeString(utcString)
  // Check for missing or invalid input
  if (!utcString || isNaN(Date.parse(utcString))) {
    return utcString;
  }

  const utcDate = new Date(utcString);

  // Convert to local time
  const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * -60000);

  let year = localDate.getFullYear();
  let month = localDate.getMonth(); // 0-indexed
  let day = localDate.getDate();
  let hours = localDate.getHours();
  let minutes = localDate.getMinutes();

  // Round minutes to nearest 10
  let roundedMinutes = Math.round(minutes / 10) * 10;

  // Handle rollover
  if (roundedMinutes === 60) {
    roundedMinutes = 0;
    hours += 1;
    if (hours === 24) {
      hours = 0;
      const nextDay = new Date(localDate);
      nextDay.setDate(day + 1);
      year = nextDay.getFullYear();
      month = nextDay.getMonth();
      day = nextDay.getDate();
    }
  }

  const pad = (n:any) => String(n).padStart(2, '0');

  return `${year}-${pad(month + 1)}-${pad(day)} ${pad(hours)}:${pad(roundedMinutes)}`;
}



export const getRoundedUTCTimeString = (utcString:any) => {
  return getLocalDateTimeString(utcString)
  if (!utcString || isNaN(Date.parse(utcString))) {
    return utcString;
  }

  const date = new Date(utcString);

  let year = date.getUTCFullYear();
  let month = date.getUTCMonth();
  let day = date.getUTCDate();
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();

  // Round minutes to nearest 10
  let roundedMinutes = Math.round(minutes / 10) * 10;

  // Handle minute overflow
  if (roundedMinutes === 60) {
    roundedMinutes = 0;
    hours += 1;
    if (hours === 24) {
      hours = 0;
      const nextDay = new Date(Date.UTC(year, month, day + 1));
      year = nextDay.getUTCFullYear();
      month = nextDay.getUTCMonth();
      day = nextDay.getUTCDate();
    }
  }

  const pad = (n:any) => String(n).padStart(2, '0');

  return `${year}-${pad(month + 1)}-${pad(day)} ${pad(hours)}:${pad(roundedMinutes)}`;
}


export const generateRandomId = (length = 12) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  
  return result;
}

export const disableScroll = () => {
  document.body.style.overflow = 'hidden';
}

export const enableScroll = () => {
  document.body.style.overflow = '';
}


export const handleLiveChat = () => {
    const button = document.getElementById('start-live-chat-button')
    if(button){
        button.click()
    }
}


